import React from 'react';
import { FUNDING_LENDER_TYPES, FUNDING_PRODUCT_TYPES, FUNDING_SUBMISSION_STATUSES } from '../../utils/funding/constants';

const FundingSubmissionFilters = ({
  search,
  status,
  lenderType,
  productType,
  onSearchChange,
  onStatusChange,
  onLenderTypeChange,
  onProductTypeChange,
}) => (
  <div className="grid gap-3 lg:grid-cols-4">
    <label className="block text-sm lg:col-span-2">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Search</span>
      <input
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Client, lender, product..."
        className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]"
      />
    </label>
    <label className="block text-sm">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Status</span>
      <select value={status} onChange={(event) => onStatusChange(event.target.value)} className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]">
        <option value="">All statuses</option>
        {FUNDING_SUBMISSION_STATUSES.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
    </label>
    <label className="block text-sm">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Lender type</span>
      <select value={lenderType} onChange={(event) => onLenderTypeChange(event.target.value)} className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]">
        <option value="">All types</option>
        {FUNDING_LENDER_TYPES.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
    </label>
    <label className="block text-sm lg:col-span-2">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Product type</span>
      <select value={productType} onChange={(event) => onProductTypeChange(event.target.value)} className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]">
        <option value="">All products</option>
        {FUNDING_PRODUCT_TYPES.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
    </label>
  </div>
);

export default FundingSubmissionFilters;
